import { render, staticRenderFns } from "./archivedSettlementList.vue?vue&type=template&id=64fee908"
import script from "./archivedSettlementList.vue?vue&type=script&lang=js"
export * from "./archivedSettlementList.vue?vue&type=script&lang=js"
import style0 from "./archivedSettlementList.vue?vue&type=style&index=0&id=64fee908&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports